import { FollowedUserInterface } from '../../..';

export class FollowedUserDto implements FollowedUserInterface {
  firstName?: string;
  id: string;
  imageUrl?: string;
  lastName?: string;
  username: string;
}
